import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useMemo } from 'react';
import clsx from 'clsx';
import { addUnit, getSizeStyle } from '../utils';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var SpinIcon = function SpinIcon(_ref) {
  var bem = _ref.bem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array(12).fill(null) // eslint-disable-next-line react/no-array-index-key
  .map(function (_, index) {
    return /*#__PURE__*/React.createElement("i", {
      key: index,
      className: clsx(bem('line', String(index + 1)))
    });
  }));
};

var CircularIcon = function CircularIcon(_ref2) {
  var bem = _ref2.bem;
  return /*#__PURE__*/React.createElement("svg", {
    className: clsx(bem('circular')),
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none"
  }));
};

var BallIcon = function BallIcon(_ref3) {
  var bem = _ref3.bem;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(bem('ball'))
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null));
};

var Icon = function Icon(bem) {
  return {
    spinner: /*#__PURE__*/React.createElement(SpinIcon, {
      bem: bem
    }),
    circular: /*#__PURE__*/React.createElement(CircularIcon, {
      bem: bem
    }),
    ball: /*#__PURE__*/React.createElement(BallIcon, {
      bem: bem
    })
  };
};

var Loading = function Loading(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('loading', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var className = props.className,
      type = props.type,
      vertical = props.vertical,
      color = props.color,
      size = props.size,
      textColor = props.textColor,
      children = props.children,
      textSize = props.textSize;
  var spinnerStyle = useMemo(function () {
    return _objectSpread({
      color: color
    }, getSizeStyle(size));
  }, [color, size]);

  var renderText = function renderText() {
    if (children) {
      return /*#__PURE__*/React.createElement("span", {
        className: clsx(bem('text')),
        style: {
          fontSize: addUnit(textSize),
          color: textColor !== null && textColor !== void 0 ? textColor : color
        }
      }, children);
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: clsx(className, bem([type, {
      vertical: vertical
    }]))
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx(bem('spinner', type)),
    style: spinnerStyle
  }, Icon(bem)[type]), renderText());
};

Loading.defaultProps = {
  type: 'circular'
};
export default Loading;